import styled from 'styled-components';

import { BODY_TEXT_COLOR, ERROR_COLOR } from '../../config/colors';

export const CONTAINER_HEIGHT = '100%';

export const emailConfirmationStyle = {
  width: '100%',
  height: '180px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
};

export const styles = {
  closeIconWrap: {
    position: 'absolute',
    right: '10px',
    top: '10px',
    cursor: 'pointer',
  },
};

const FormWrapperDiv = styled.div`
    display: flex;
    color: ${BODY_TEXT_COLOR};
    flex-direction: column;
    font-size: 18px;
    align-items: center;
    justify-content: center;
    margin: 0 auto 0;
    height: 100%;
    font-family: 'Futura-Bold', 'Futura-Bold';
`;

const ErrorDiv = styled.div`
  color: ${ERROR_COLOR}
`;

const HeaderTitle = styled.div`
  text-align: center;
  margin-top: 18px;
  font-size: 21px;
  font-weight: 800;
  font-family: 'Futura-Bold';
  color: ${BODY_TEXT_COLOR};
`;

export {
  FormWrapperDiv,
  ErrorDiv,
  HeaderTitle,
};



// WEBPACK FOOTER //
// ./src/components/EmailUpdateConfirmationModal/styles.js